// Login.js
import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext'; // Importa il hook useAuth
import { useNavigate } from 'react-router-dom'; // Importa il hook useNavigate

import { BASE_URL } from './config';


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Login = () => {
  const { login } = useAuth(); // Estrai la funzione login dal contesto di autenticazione
  const navigate = useNavigate(); // Ottieni la funzione navigate dalla libreria React Router

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [platform, setPlatform] = useState('WEB');

  const handleLogin = async () => {
    try {
      const response = await axios.post(BASE_URL + '/v1/user/login', { username, password, platform });
      console.log(response.data);
      const token = response.data.accessToken;
      const roles = response.data.userRoles;
      login(token, roles); // Utilizza la funzione login dal contesto di autenticazione

      // Dopo il login, esegui il reindirizzamento alla pagina desiderata
      sessionStorage.setItem('accessToken', token);
      

      navigate('/');
    } catch (error) {

      
        toast.success('Questo è un toast di errore!', {
          position: toast.POSITION.TOP_RIGHT, // Posizione del toast
          autoClose: 3000, // Durata in millisecondi (3000ms = 3 secondi)
          hideProgressBar: false, // Mostra/nascondi la barra di avanzamento
        });
      console.error('Errore durante il login:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <form>
        <label>
          Username:
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
        </label>
        <br />
        <label>
          Password:
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <input type="hidden" value={platform} onLoad={(e) => setPlatform('WEB')} />
        <br />
        <button type="button" onClick={handleLogin}>Login</button>
      </form>
      <ToastContainer/>
    </div>
  );
};

export default Login;
